import React, { useCallback } from 'react';
import HeaderNavigation from '../../../headers/HeaderNavigation/HeaderNavigation';
import UserInfo from '../../../headers/UserInfo/UserInfo';
import PageHeader from '../../../headers/PageHeader/PageHeader';
import { confirmAlert } from '../../../../services/mini/alanConfirmAlert';
import ConceptVideoToolWrapper from '../../../components/ConceptVideoToolWrapper/ConceptVideoToolWrapper';
import { connect } from 'react-redux';
import * as actions from '../../../../redux/projects/actions.projects';
import asyncDispatch from '../../../../services/mini/asyncDispatch';
import NewProjectTemplatePopup from '../NewProjectTemplatePopup/NewProjectTemplatePopup';
import store from '../../../../store';
import videoToolIcon from '../../../../assets/images/video-tool-icon.svg';
import { isUserBalancePositive } from '../../../../services/mini/isUserBalancePositive';
import history from '../../../../history';
import { routeInfo } from '../../../../routeInfo';

function ProjectsHeader({ addNewProject, projects, user }) {
    const addNewProjectCb = useCallback(() => {

        if (!isUserBalancePositive(user)) {
            history.push(routeInfo.billing.url());
            return;
        }

        confirmAlert({
            customUI: ({ onClose }) => {
                return <NewProjectTemplatePopup
                    onClose={onClose}
                    store={store} />;
            }
        });
    }, [user]);

    return <PageHeader
        leftPart={
            <React.Fragment>
                <HeaderNavigation hideBackButton={true} />
            </React.Fragment>
        }
        rightPart={
            <React.Fragment>
                <ConceptVideoToolWrapper>
                    <a href={'/tools/videoTool4.html'}
                        className="action-btn light-blue-with-border projects-header_new-project">
                        <i><img className="icon" src={videoToolIcon} /></i>

                        <div className="projects-header_new-project_text mobile-only">
                            Video
                        </div>
                        <div className="projects-header_new-project_text tablet-and-bigger">
                            Concept Video Tool
                        </div>
                    </a>
                </ConceptVideoToolWrapper>
                <div onClick={addNewProjectCb}
                    className="action-btn light-blue-with-border projects-header_new-project">
                    <i className="icon icon-alan-plus-sign" />
                    <div className="projects-header_new-project_text mobile-only">
                        Create
                    </div>
                    <div className="projects-header_new-project_text tablet-and-bigger">
                        Create Project
                    </div>
                </div>
                <UserInfo />
            </React.Fragment>
        }
    />;
}

function mapStateToProps({ projectsInfo, user }) {
    return {
        projects: projectsInfo.projects,
        user: user,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        addNewProject: (param) => asyncDispatch(actions.addNewProject, dispatch, param),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectsHeader);
